import Http from "@/api/http";

export default {
  /* 宿舍 列表 */
  schoolDormitoryPage: params => {
    return Http.POST("/schoolDormitorySet/findByPage", params);
  },
  /* 查询宿舍最新的20条识别记录 */
  findLastDormitorySignRecord: params => {
    return Http.POST(
      "/monitoringScreen/findLastDormitorySignRecord",
      null,
      {
        showCodeInPage: true,
      },
      params
    );
  },
  /* 查询在宿舍楼待超过12个小时的人员 */
  findInDormitory: params => {
    return Http.POST(
      "/monitoringScreen/findInDormitory",
      null,
      {
        showCodeInPage: true,
      },
      params
    );
  },
  /* 统计每个班级总人数，在宿舍，离宿舍人数 */
  findAllGradeClass: params => {
    return Http.POST(
      "/monitoringScreen/findAllGradeClass",
      null,
      {
        showCodeInPage: true,
      },
      params
    );
  },
};
